<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M9.4 18L8 16.6l4.6-4.6L8 7.4 9.4 6l6 6-6 6z"/></svg>